module.exports = __webpack_public_path__ + "img/10.df071c6e.png";